import { render, staticRenderFns } from "./UserUpdateComponent.vue?vue&type=template&id=0bfd0709"
import script from "./UserUpdateComponent.vue?vue&type=script&lang=js"
export * from "./UserUpdateComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/UserUpdateComponent.vue
// module id = null
// module chunks = 